import React, { useEffect, useState } from 'react';
import './index.scss';
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
export interface ButtonItem {
  label: string;
  isActive: boolean;
  value: any;
  clstag?: CLSTAG;
}
interface ButtonRadioProps {
  btnGroup: ButtonItem[];
  needConfirm?: boolean;
  onChange: AnyFunc;
}
const ButtonRadio = (props: ButtonRadioProps) => {
  const { btnGroup, needConfirm = false } = props;
  const findIndex = btnGroup.findIndex(
    (item: ButtonItem) => item.isActive === true
  );
  const [activeBtnIndex, setActiveBtnIndex] = useState(findIndex);
  const onChange = (selectItem: ButtonItem, index: number, evt: any) => {
    if (!needConfirm) {
      setActiveBtnIndex(index);
    }
    props.onChange && props.onChange(selectItem);
  };

  useEffect(() => {
    const findIndex = btnGroup.findIndex(
      (item: ButtonItem) => item.isActive === true
    );
    setActiveBtnIndex(findIndex);
  }, [btnGroup]);
  return (
    <div className="btn-group">
      {props.btnGroup.map((item: any, index: number) => (
        <span
          clstag={item.clstag && clstagStr(item.clstag)}
          key={index}
          onClick={onChange.bind(null, item, index)}
          className={index === activeBtnIndex ? 'btn-active ' : 'btn-normal'}
        >
          {item.label}
        </span>
      ))}
    </div>
  );
};

export default React.memo(ButtonRadio);
